export const countryNameToCode: Record<string, string> = {
  "United Arab Emirates": "AE",
  "Bahrain": "BH",
  "Qatar": "QA",
  "Kuwait": "KW",
  "Oman": "OM",
  "Bangladesh": "BD",
  "United Kingdom": "GB",
  "India": "IN",
  "Sri Lanka": "LK",
  "Pakistan": "PK",
  "Afghanistan": "AF",
  "Egypt": "EG",
  "Iraq": "IQ",
  "Jordan": "JO",
  "Lebanon": "LB",
  "Saudi Arabia": "SA",
  "Switzerland": "CH",
  "Germany": "DE",
  "France": "FR",
  "Ireland, Republic of": "IE",
  "Italy": "IT",
  "Netherlands": "NL",
  "Belgium": "BE",
  "Canada": "CA",
  "United States": "US",
  "Australia": "AU",
  "Brunei Darussalam": "BN",
  "Bhutan": "BT",
  "China": "CN",
  "Hong Kong": "HK",
  "Indonesia": "ID",
  "Japan": "JP",
  "Cambodia": "KH",
  "North Korea": "KP",
  "South Korea": "KR",
  "Laos": "LA",
  "Malaysia": "MY",
  "Nepal": "NP",
  "New Zealand": "NZ",
  "Philippines": "PH",
  "Singapore": "SG",
  "Thailand": "TH",
  "East Timor": "TL",
  "Taiwan": "TW",
  "Vietnam": "VN",
  "Andorra": "AD",
  "Albania": "AL",
  "Austria": "AT",
  "Bosnia": "BA",
  "Bulgaria": "BG",
  "Brazil": "BR",
  "Cyprus": "CY",
  "Czech Republic": "CZ",
  "Denmark": "DK",
  "Estonia": "EE",
  "Spain": "ES",
  "Finland": "FI",
  "Guernsey": "GG",
  "Greece": "GR",
  "Croatia": "HR",
  "Hungary": "HU",
  "Iceland": "IS",
  "Jersey": "JE",
  "Lithuania": "LT",
  "Latvia": "LV",
  "Moldova": "MD",
  "Montenegro": "ME",
  "Macedonia": "MK",
  "Mongolia": "MN",
  "Malta": "MT",
  "Norway": "NO",
  "Portugal": "PT",
  "Romania": "RO",
  "Serbia": "RS",
  "Slovenia": "SI",
  "Sweden": "SE",
  "Slovakia": "SK",
  "Turkey": "TR",
  "South Africa": "ZA",
  "Poland": "PL",
  "Antigua": "AG",
  "Anguilla": "AI",
  "Armenia": "AM",
  "Angola": "AO",
  "Argentina": "AR",
  "American Samoa": "AS",
  "Azerbaijan": "AZ",
  "Barbados": "BB",
  "Burkina Faso": "BF",
  "Burundi": "BI",
  "Benin": "BJ",
  "Bermuda": "BM",
  "Bolivia": "BO",
  "Bahamas": "BS",
  "Botswana": "BW",
  "Belize": "BZ",
  "Congo": "CG",
  "Central African Republic": "CF",
  "Ivory Coast": "CI",
  "Cook Islands": "CK",
  "Chile": "CL",
  "Cameroon": "CM",
  "Colombia": "CO",
  "Costa Rica": "CR",
  "Cuba": "CU",
  "Cape Verde": "CV",
  "Djibouti": "DJ",
  "Dominica": "DM",
  "Dominican Republic": "DO",
  "Algeria": "DZ",
  "Ecuador": "EC",
  "Eritrea": "ER",
  "Ethiopia": "ET",
  "Falkland Islands": "FK",
  "Faroe Islands": "FO",
  "Fiji": "FJ",
  "Gabon": "GA",
  "Georgia": "GE",
  "French Guiana": "GF",
  "Ghana": "GH",
  "Greenland": "GL",
  "Gambia": "GM",
  "Guadeloupe": "GP",
  "Equatorial Guinea": "GQ",
  "Guam": "GU",
  "Guyana": "GY",
  "Honduras": "HN",
  "Iran": "IR",
  "Jamaica": "JM",
  "Kenya": "KE",
  "Kiribati": "KI",
  "Saint Kitts And Nevis": "KN",
  "Kosovo": "KV",
  "Cayman Islands": "KY",
  "Kazakhstan": "KZ",
  "Saint Lucia": "LC",
  "Liberia": "LR",
  "Lesotho": "LS",
  "Libya": "LY",
  "Morocco": "MA",
  "Monaco": "MC",
  "Madagascar": "MG",
  "Marshall Islands": "MH",
  "Mali": "ML",
  "Martinique": "MQ",
  "Mauritania": "MR",
  "Montserrat": "MS",
  "Mauritius": "MU",
  "Maldives": "MV",
  "Malawi": "MW",
  "Mexico": "MX",
  "Mozambique": "MZ",
  "Myanmar": "MM",
  "Namibia": "NA",
  "Niger": "NE",
  "Nigeria": "NG",
  "Nicaragua": "NI",
  "Niue": "NU",
  "Panama": "PA",
  "Peru": "PE",
  "Papua New Guinea": "PG",
  "Paraguay": "PY",
  "Solomon Islands": "SB",
  "Sudan": "SD",
  "Sierra Leone": "SL",
  "San Marino": "SM",
  "Senegal": "SN",
  "Somalia": "SO",
  "Suriname": "SR",
  "Sao Tome And Principe": "ST",
  "Syria": "SY",
  "Swaziland": "SZ",
  "Turks And Caicos Islands": "TC",
  "Togo": "TG",
  "Tajikistan": "TJ",
  "Turkmenistan": "TM",
  "Tunisia": "TN",
  "Tonga": "TO",
  "Trinidad And Tobago": "TT",
  "Tanzania": "TZ",
  "Uganda": "UG",
  "Uruguay": "UY",
  "Uzbekistan": "UZ",
  "Saint Vincent And Grenadines": "VC",
  "Venezuela": "VE",
  "Virgin Islands, British": "VG",
  "Virgin Islands, US": "VI",
  "Vanuatu": "VU",
  "Samoa": "WS",
  "Bonaire": "XB",
  "Curacao": "XC",
  "Saint Eustatius": "BQ",
  "Sint Maarten": "SX",
  "Saint Barthelemy": "BL",
  "Yemen": "YE",
  "Mayotte": "YT",
  "Zambia": "ZM",
  "Zimbabwe": "ZW",
  "Seychelles": "SC",
  "South Sudan": "SS",
  "Mariana Islands": "MP",
  "Aruba": "AW",
  "Guatemala": "GT",
  "Liechtenstein": "LI",
  "Guinea Republic": "GN",
  "Rwanda": "RW",
  "Israel": "IL",
  "Luxembourg": "LU",
  "Gibraltar": "GI",
  "Canary Islands, The": "IC",
  "Chad": "TD",
  "Comoros": "KM",
  "El Salvador": "SV",
  "Guinea Bissau": "GW",
  "Haiti": "HT",
  "Kyrgyzstan": "KG",
  "Dubai": "DXB",
  "Abu Dhabi": "AUH",
  "Sharjah": "SHJ",
  "Ajman": "AJM",
  "Umm Al Quwain": "UAQ",
  "Ras Al Khaimah": "RAK",
  "Al Ain": "ALN",
  "Fujairah": "FUJ"
};

// Helper function to get country code from country name
export const getCountryCode = (countryName: string): string => {
  return countryNameToCode[countryName] || countryName;
};

// Helper function to get country name from code (reverse lookup)
export const getCountryName = (countryCode: string): string => {
  const entry = Object.entries(countryNameToCode).find(([, code]) => code === countryCode);
  return entry ? entry[0] : countryCode;
};

